// extracted by mini-css-extract-plugin
module.exports = {"err-doctor-dialog":"err-doctor-dialog-aeb268fe4729767818011007e542789d","button-div":"button-div-19914d2fcc0d6bc307684e7b3060c39b"};